// QRScanner.js
//import { BrowserMultiFormatReader } from '@zxing/library';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { qrcodeVarificationRequest } from '../../../../store/actions';
import { IKioskMessage, IKIOSKModel } from '../../../../models/kioskModel';
import { Ilanguages } from '../../../../models/utilitiesModel';
import { useTranslation } from 'react-i18next';
import qrCode from '../../../../images/Qr_Code.gif';
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

const QRScannerLogin = () => {
    const { t } = useTranslation("translations");
    // const videoRef: any = useRef(null);
    const inputRef: any = useRef(null);
    const [qrResult, setQrResult]: any = useState(null);
    const dispatch = useDispatch();
    const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
    
    useEffect(() => {
        if (((qrResult as string) ||'')?.endsWith("=")) {
            dispatch(qrcodeVarificationRequest(qrResult));
        }
    }, [qrResult]);

    useEffect(() => {
        inputRef.current.focus();

        const handleClick = () => {
            inputRef.current.focus();
        };
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);



    // useEffect(() => {
    //     const codeReader = new BrowserMultiFormatReader();
    //     const startScanner = async () => {
    //         try {
    //             await codeReader.decodeFromVideoDevice(
    //                 null, // Automatically selects the default camera
    //                 videoRef.current,
    //                 (result: any, error: any) => {
    //                     if (result) {
    //                         setQrResult(result.getText());
    //                         console.log('code_Reader_text==>', result.getText())
    //                         codeReader.reset(); // Stop the scanner after a successful read
    //                     }
    //                     if (error) {
    //                         console.error("somthig went wrong:", error);
    //                     }
    //                 },
    //                 // { formats: [BarcodeFormat.CODE_128, BarcodeFormat.QR_CODE] }
    //             );
    //         } catch (err) {
    //             console.error("Error initializing QR code scanner:", err);
    //         }
    //     };
    //     startScanner();
    //     return () => {
    //         codeReader.reset(); // Cleanup when the component is unmounted
    //     };
    // }, [dispatch, language, t]);

    return (
        <div id='click' style={{ textAlign: "center" }}>
            <h2>{(getLabelConfigMsg(kioskConfigMsgs,language,"qrscan") || t("kiosktranslation.qrscan" + language))}</h2>
            {/* <video ref={videoRef} id='video' style={{ width: "100%", maxWidth: "400px" }} /> */}
            <img src={qrCode} alt={t("kiosktranslation.cardreader" + language)} width="180px" className='my-2' />
            <input ref={inputRef} onChange={(e) => setQrResult(e.target.value)} style={{ opacity: 0, display: 'block' }} />
        </div>
    );
};

export default QRScannerLogin;
